module.exports = __webpack_public_path__ + "static/media/thomas-cook-logo-charcoal.f1812535.svg";